// Utilities always available to every compiled Genie component (both UI and
// form mode). Exported here so both engine files can import without duplicating.

export const traverseDotPath = (obj: Record<string, any>, path: string): unknown =>
  path.split('.').reduce((cur: any, key: string) => cur?.[key], obj);

export const formPrefillFunction = (
  parserResults: Record<string, any>,
  runtimeFormConfig: Record<string, any>
): Record<string, unknown> => {
  const result: Record<string, unknown> = {};
  (runtimeFormConfig?.sections ?? []).forEach((section: Record<string, any>) =>
    (section.fields ?? []).forEach((field: Record<string, any>) => {
      const value =
        parserResults?.[field.schemaPath] ?? parserResults?.[field.id];
      if (value !== undefined && value !== null) {
        result[field.id] = value;
      }
    })
  );
  return result;
};

export const UNIVERSAL_FUNCTIONS: Record<string, unknown> = {
  traverseDotPath,
  formPrefillFunction,
};
